import type { ComponentProps, FunctionComponent } from 'react';

import { TeamProvider, TeamProviderProps } from '@suntex.fim/team';

type WithTeamProps = Pick<TeamProviderProps, 'teamId'>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function wrapForTeam<C extends FunctionComponent<any>>(Component: C) {
  type OriginalProps = ComponentProps<C>;
  type WrappedProps = Omit<OriginalProps, keyof WithTeamProps> & WithTeamProps;

  return ({ teamId, ...props }: WrappedProps): JSX.Element => {
    return (
      <TeamProvider teamId={teamId}>
        <Component {...(props as OriginalProps)} />
      </TeamProvider>
    );
  };
}
